import HumanMessage from 'modals/AIChatModal/components/ChatMessageList/components/HumanMessage'
import styled from 'styled-components'
import ChatAnimation, { StyledChatAnimationWrapper } from '../ChatAnimation'

export interface Message {
    icon: string
    message: string
    date: string
    name: string
    curlString?: string
    prompt?: string
}

type TextWindowProps = {
    loading: boolean
    messages: Message[]
    scrollRef?: React.RefObject<HTMLDivElement>
}

const TextChatWindow = ({ messages, loading, scrollRef }: TextWindowProps) => {
    const currentDate = new Date().toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
    })

    const reversedMessages = [...messages]?.reverse()

    return (
        <StyledResponse>
            <div ref={scrollRef} />
            <StyledDivider />

            {loading && (
                <>
                    <HumanMessage
                        avatarImg={''}
                        messageDate={currentDate}
                        messageText={'...'}
                        userName={'Generating'}
                        loading
                    />
                </>
            )}

            {messages?.length === 0 && !loading && (
                <StyledChatAnimationWrapper>
                    <ChatAnimation />
                </StyledChatAnimationWrapper>
            )}
            {reversedMessages?.map((message, index) => {
                return (
                    <HumanMessage
                        key={index}
                        avatarImg={message.icon}
                        messageDate={message.date}
                        messageText={message.message}
                        userName={message.name}
                        curlString={message.curlString}
                    />
                )
            })}
        </StyledResponse>
    )
}

export default TextChatWindow

export const StyledResponse = styled.div`
    width: 100%;
    height: 100%;
    padding: 20px;

    display: flex;
    flex-direction: column-reverse;

    gap: 20px;

    overflow: auto;

    padding-bottom: 40px;
`

export const StyledDivider = styled.div`
    margin-bottom: auto;
`
